import React, { FC } from 'react'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import { InlineSwitch } from '@new/__global/components/Filters/FiltersVariations/InlineSwitch'

interface OffboardedHomesFilterProps extends FiltersSharedProps {
  initialValue?: boolean
  isSidebarFilter?: boolean
  onChange: (value?: boolean) => void
}

export const OffboardedHomes: FC<OffboardedHomesFilterProps> = props => {
  return <InlineSwitch title="Show Off-boarded" {...props} />
}
